import { z } from 'zod';

// 계좌 인증 API 타입
export const ValidateAccountInfoRequestSchema = z.object({
  bankName: z.string(),
  accountNumber: z.string(),
  accountHolder: z.string(),
});

export type ValidateAccountInfoRequest = z.infer<typeof ValidateAccountInfoRequestSchema>;

export const ValidateAccountInfoResponseSchema = z.object({
  isValid: z.boolean(),
  failureReason: z.string().nullable(),
});

export type ValidateAccountInfoResponse = z.infer<typeof ValidateAccountInfoResponseSchema>;
